var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGlasses = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.04134 12.9167C7.53711 12.9167 8.74967 11.7041 8.74967 10.2083C8.74967 8.71256 7.53711 7.5 6.04134 7.5C4.54557 7.5 3.33301 8.71256 3.33301 10.2083C3.33301 11.7041 4.54557 12.9167 6.04134 12.9167Z",
  stroke: "white",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9582 12.9167C12.4624 12.9167 11.2498 11.7041 11.2498 10.2083C11.2498 8.71256 12.4624 7.5 13.9582 7.5C15.4539 7.5 16.6665 8.71256 16.6665 10.2083C16.6665 11.7041 15.4539 12.9167 13.9582 12.9167Z",
  stroke: "white",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.6665 9.99992H3.33317M18.3332 9.99992H16.6665M8.33317 8.74992C8.5415 7.91659 9.1665 7.08325 9.99984 7.08325C10.8332 7.08325 11.4582 7.91659 11.6665 8.74992",
  stroke: "white",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconGlasses;